<div class="user-profile-picture" routerLinkActive="router-link-active" tabindex="-1" [routerLink]="[_dynamicRoute]">
  <img
    *ngIf="!_isProfilePicLoading"
    alt="Profile Picture"
    style="border-radius: 10px"
    tabindex="-1"
    [src]="_assets + _userProfilePic"
    (error)="handleImageError($event)"
  />
  <img
    *ngIf="_isProfilePicLoading"
    style="border-radius: 16px 8px 16px 8px"
    tabindex="-1"
    [src]="_DefaultProfilePic"
    (error)="handleImageError($event)"
  />
</div>
